module.exports = __webpack_public_path__ + "img/图.f0e48d28.webp";